import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MembershipPeriodUsageSummary from './MembershipPeriodUsageSummary';
import MembershipPeriodUsageBreakdownTable from './MembershipPeriodUsageBreakdownTable';
import { DEFAULT_CURRENCY } from '../../utils/currencyUtils';
import { BRAND } from '../../theme/brandTokens';

const MembershipPeriodUsagePanel = ({
  detail,
  currencyCode = DEFAULT_CURRENCY,
}) => {
  const { t } = useTranslation();

  if (!detail) {
    return null;
  }

  return (
    <Stack spacing={2.5}>
      <Box>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, color: BRAND.primaryText }}>
          {t('employeePayments.payroll.membershipPeriod.title')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {t('employeePayments.payroll.membershipPeriod.subtitle')}
        </Typography>
      </Box>
      <MembershipPeriodUsageSummary detail={detail} currencyCode={currencyCode} />
      <MembershipPeriodUsageBreakdownTable periods={detail.periods} currencyCode={currencyCode} />
    </Stack>
  );
};

export default MembershipPeriodUsagePanel;
